/** Full-screen tint that pulses briefly on each answer — visible even where the answer sheet doesn't cover. */
export class FeedbackFlash {
  private readonly el = this.getElement('#feedback-flash');

  trigger(correct: boolean): void {
    this.el.classList.remove('flash-correct', 'flash-incorrect');
    void this.el.offsetWidth; // force reflow so the animation restarts on repeat triggers
    this.el.classList.add(correct ? 'flash-correct' : 'flash-incorrect');
  }

  private getElement<T extends HTMLElement = HTMLElement>(selector: string): T {
    const element = document.querySelector<T>(selector);
    if (!element) throw new Error(`Missing element: ${selector}`);
    return element;
  }
}
